export interface TPuzzleLessonComponent {
  id: string;
  keyword: string;
  image: string;
  x: number; // percentage (0-100)
  y: number; // percentage (0-100)
  width: number; // percentage of container width
  height: number; // percentage of container height
  required?: boolean;
}

export interface TPuzzleLessonConfig {
  statement?: string;
  backgroundImage?: string;
  components: TPuzzleLessonComponent[];
  placeholderOpacity?: number;
  requiredMatches?: number;
}

export const createEmptyPuzzleLessonConfig = (): TPuzzleLessonConfig => ({
  statement: "",
  backgroundImage: "",
  components: [],
  placeholderOpacity: 0.35,
  requiredMatches: 0,
});
